"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doesMeetingSupportChitSystem = exports.formatMeetingID = exports.extractOnlineMeetingPasswordFromURL = exports.extractOnlineMeetingIdFromURL = exports.detectOnlineMeetingTypeFromURL = exports.px2cm = exports.addNumToPage = exports.filterMeetingsByOutwardCodes = exports.filterMeetingsByDistrict = exports.sortMeetings = exports.numToDay = exports.dayToNum = exports.chitSystemRegex = exports.gotoMeetingUrlRegex = exports.zoomUrlRegex = exports.onlineMeetingPasswordRegex = exports.onlineMeetingIdRegex = exports.postcodeAreaRegex = exports.postcodeRegex = void 0;
const types_1 = require("./types");
exports.postcodeRegex = new RegExp(/([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/);
exports.postcodeAreaRegex = new RegExp(/[A-Z]{1,2}[0-9]+/);
exports.onlineMeetingIdRegex = new RegExp(/id:\s?([\d\s]+)/, 'i');
exports.onlineMeetingPasswordRegex = new RegExp(/pass(word|code):\s?([a-zA-Z\d]+)/, 'i');
exports.zoomUrlRegex = new RegExp(/https:\/\/([\w\.]+)?zoom\.us\/j\/([\d]+)(\?pwd=.+)?$/);
exports.gotoMeetingUrlRegex = new RegExp(/https:\/\/([\w\.]+)(gotomeeting.com|gotomeet.me)\/([\w]+)$/);
exports.chitSystemRegex = new RegExp(/chit[\s\n\r\t]+/, 'i');
const dayToNum = (day) => {
    switch (day) {
        case 'Monday': return 0;
        case 'Tuesday': return 1;
        case 'Wednesday': return 2;
        case 'Thursday': return 3;
        case 'Friday': return 4;
        case 'Saturday': return 5;
        case 'Sunday': return 6;
    }
};
exports.dayToNum = dayToNum;
const numToDay = (day) => {
    switch (day) {
        case 0: return 'Sunday';
        case 1: return 'Monday';
        case 2: return 'Tuesday';
        case 3: return 'Wednesday';
        case 4: return 'Thursday';
        case 5: return 'Friday';
        case 6: return 'Saturday';
        default: throw new Error(`Cannot match number '${day}' to day`);
    }
};
exports.numToDay = numToDay;
const sortMeetings = (data) => {
    data.sort((a, b) => {
        if (a.time && !b.time)
            return 1;
        if (b.time && !a.time)
            return -1;
        return parseInt(a.time.replace(':', ''), 10) - parseInt(b.time.replace(':', ''), 10);
    });
    data.sort((a, b) => {
        return (0, exports.dayToNum)((0, exports.numToDay)(parseInt(a.day, 10))) - (0, exports.dayToNum)((0, exports.numToDay)(parseInt(b.day, 10)));
    });
};
exports.sortMeetings = sortMeetings;
const filterMeetingsByDistrict = (data, district, subDistrict = undefined) => {
    return data.filter(meeting => {
        if (meeting.district === district) {
            if (subDistrict) {
                return meeting.sub_district === subDistrict;
            }
            return true;
        }
    });
};
exports.filterMeetingsByDistrict = filterMeetingsByDistrict;
const filterMeetingsByOutwardCodes = (data, outwardCodes) => {
    if (!outwardCodes.length) {
        return data;
    }
    console.log("Filter", outwardCodes);
    return data.filter((meeting) => {
        console.log(meeting.formatted_address);
        let matches = exports.postcodeRegex.exec(meeting.formatted_address);
        let postcode;
        console.log("Matches", matches);
        if (!matches || !matches.length) {
            matches = exports.postcodeAreaRegex.exec(meeting.formatted_address);
            if (matches && matches.length) {
                postcode = matches[0];
            }
        }
        else {
            matches = exports.postcodeAreaRegex.exec(matches[0]);
            postcode = matches[0];
        }
        exports.postcodeRegex.lastIndex = 0;
        exports.postcodeAreaRegex.lastIndex = 0;
        console.log("Postcode", postcode);
        return outwardCodes.includes(postcode);
    });
};
exports.filterMeetingsByOutwardCodes = filterMeetingsByOutwardCodes;
const addNumToPage = (page, pageNum) => {
    const nums = page.getElementsByClassName('page-num');
    if (nums.length === 1) {
        const num = nums[0];
        if (num.innerHTML === '_AUTOGEN_') {
            num.innerHTML = (pageNum).toString();
        }
    }
};
exports.addNumToPage = addNumToPage;
const px2cm = () => {
    const d = document.createElement('div');
    d.setAttribute('style', 'position: absolute; top: -1000cm; left: -1000cm; height: 1000cm; width: 1000cm;');
    document.body.appendChild(d);
    const px_per_cm = d.getBoundingClientRect().height / 1000;
    document.body.removeChild(d);
    return px_per_cm;
};
exports.px2cm = px2cm;
const detectOnlineMeetingTypeFromURL = (url) => {
    if (exports.zoomUrlRegex.test(url)) {
        return types_1.ONLINE_MEETING_TYPE.ZOOM;
    }
    if (exports.gotoMeetingUrlRegex.test(url)) {
        return types_1.ONLINE_MEETING_TYPE.GOTOMEETING;
    }
    return types_1.ONLINE_MEETING_TYPE.UNKNOWN;
};
exports.detectOnlineMeetingTypeFromURL = detectOnlineMeetingTypeFromURL;
const extractOnlineMeetingIdFromURL = (url) => {
    const type = (0, exports.detectOnlineMeetingTypeFromURL)(url);
    switch (type) {
        case types_1.ONLINE_MEETING_TYPE.GOTOMEETING:
            return exports.gotoMeetingUrlRegex.exec(url)[3];
        case types_1.ONLINE_MEETING_TYPE.ZOOM:
            return exports.zoomUrlRegex.exec(url)[2];
    }
    return null;
};
exports.extractOnlineMeetingIdFromURL = extractOnlineMeetingIdFromURL;
const extractOnlineMeetingPasswordFromURL = (url) => {
    const type = (0, exports.detectOnlineMeetingTypeFromURL)(url);
    let matches;
    switch (type) {
        case types_1.ONLINE_MEETING_TYPE.ZOOM:
            matches = exports.zoomUrlRegex.exec(url);
            if (matches.length === 4) {
                return matches[3];
            }
            break;
    }
    return null;
};
exports.extractOnlineMeetingPasswordFromURL = extractOnlineMeetingPasswordFromURL;
const formatMeetingID = (id, type) => {
    let result = id;
    switch (type) {
        case types_1.ONLINE_MEETING_TYPE.ZOOM:
            if (id.length === 9 || id.length === 10) {
                result = `${id.substr(0, 3)} ${id.substr(3, 3)} ${id.substr(6)}`;
            }
            else if (id.length > 10) {
                result = `${id.substr(0, 3)} ${id.substr(3, 4)} ${id.substr(7)}`;
            }
    }
    return result;
};
exports.formatMeetingID = formatMeetingID;
const doesMeetingSupportChitSystem = (meeting) => {
    return meeting.types.includes('CH') || exports.chitSystemRegex.test(meeting.notes);
};
exports.doesMeetingSupportChitSystem = doesMeetingSupportChitSystem;
